<!--테스트 http://localhost:7777/checkoutPoint?point=3000&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtZW1iZXJfbm8iOiIxNjI1NTA0MDEwNzIwIiwiZW1haWwiOiIiLCJuYW1lIjoi64uJIiwidHlwZSI6InBob25lIiwicHJvZmlsZSI6bnVsbCwiaWF0IjoxNjI1NTA0MDExLCJleHAiOjE3MTE5MDQwMTEsImlzcyI6IioiLCJzdWIiOiJ1c2VySW5mbyJ9._se78Z3Q_kaujm_rwBa8-2uVrk2VNTYDg3nRUfu9lBY-->
 
<!-- 원본 보존
<template>
    <section>
        <div v-if="!success">
            <h1>주문 페이지</h1>
            <div>주문번호 : {{order_id}}</div>
            <div>상품번호 : {{product_id}}</div>
            <div>상품명 : {{product_name}}</div>
            <div>가격 : {{price}}</div>
            <div>수량 : {{qty}}</div>
            <div>이름 : {{name}}</div>
            <div>전화번호 : {{phone}}</div>
            <div>주소 : {{road_address_name}}</div>
            <div>상세 주소 : {{address_detail}}</div>
            <div>우편번호 : {{post}}</div>
            <div>배송비 : {{shipping}}</div>
            <div>최종가격 : {{amount}}</div>
            
            <div @click="openDaumPostCode()">[주소 변경]</div>
            <div @click="order()">[주문]</div>

            <DaumPostCode :open="showDaumPostCode" @selected="onAddressSelected" />
        </div>
        <loading v-show="loading"/>
    </section>
</template>
 원본 보존 -->

<template>
  <section class="mobile_wrap">
    <div v-if="!success">
      <div class="order__content">
        <div class="order__details">
          <p>주문내역</p>
          <ul class="product_list">
            <!-- 반복 -->
            <li>
              <h3>예치금 충전</h3>
              <dl class="item_subinfo">
                <dd>충전포인트 : {{ point.toLocaleString("ko-KR") }}원</dd>
              </dl>
            </li>
            <!-- 반복 -->
          </ul>
        </div>
      </div>
      <div class="order__footer">
        <p>
          총 <span>{{ amount.toLocaleString("ko-KR") }}</span
          >원
        </p>
        <button @click="order()">결제하기</button>
      </div>
    </div>
    <loading v-show="loading" />
    <div v-if="isSelect" class="selectBg" @click="on_select">
      <ul>
        <li
          v-for="(item, index) in selects"
          :key="index"
          @click="on_select_data(item)"
        >
          <span v-bind:class="{ active: item == selectData }">{{ item }}</span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { useRoute } from "vue-router";
import client from "../client/client";
import { PGS } from "../order/constants";
import Utils from "../order/utils";
import Loading from "../components/Loading";
import { importId } from "../order/importpay";

export default {
  name: "Checkout",
  components: {
    Loading,
  },
  data: function () {
    const route = useRoute();
    const { query } = route;
    return {
      loading: true,
      success: false,
      query: query,
      form: this.$form.createForm(this, { name: "payment" }),
      initialMerchantUid: `mid_${new Date().getTime()}`,
      pgs: PGS,
      methods: Utils.getMethodsByPg(),
      quotas: Utils.getQuotaByPg(),
      initialMethod: "card",
      vbankDueVisible: false,
      bizNumVisible: false,
      quotaVisible: true,

      point: 0,
      amount: 0,
      order_id: "",
      delivery: "delivery",

      // 체크
      checkedValues: [],
    };
  },
  methods: {
    async update() {
      const route = useRoute();
      const { query } = route;
      client.updateToken(query);
      this.amount = this.point = parseInt(query.point);
      let my = await client.get(`/api/my`);
      this.phone = my.phone;
      this.name = my.name;

      if (my.road_address_name || my.address_name) {
        this.address = {
          road_address_name: my.road_address_name,
          address_name: my.address_name,
          address_detail: my.address_detail,
          place_name: my.place_name,
          address_x: my.address_x,
          address_y: my.address_y,
        };
      } else {
        this.address_text = "미입력";
      }

      this.host = window.location.protocol + "//" + window.location.host;
      this.loading = false;
    },

    async order(e) {
      this.loading = true;

      let order = await client.post(`/api/order/start`, {
        type: "예치금",
        point: this.point,
        amount: this.amount,
      });

      if (!order || !order.order_id) {
        alert(
          "일시적 오류가 발생하였습니다. 잠시 후 다시 시도해주세요 " +
            JSON.stringify(order, null, 2)
        );
        return;
      }

      const { IMP } = window;
      IMP.init(importId);
      const data = {
        pg: "html5_inicis",
        pay_method: "card",
        escrow: false,
        merchant_uid: order.order_id,
        name: order.order_name,
        amount: order.amount,
        buyer_name: this.name,
        buyer_tel: this.phone,
        buyer_email: "",
        buyer_addr: `${this.address.address_text}`,
        buyer_postcode: this.address.address_post,
        niceMobileV2: true,
        m_redirect_url: this.host + "/checkout/complete",
      };

      if (data.payMethod === "card") {
        data.display = {
          card_quota: 0,
        };
      }

      IMP.request_pay(data, this.callback);
      this.loading = false;
    },
    callback(response) {
      alert(response);
    },
  },
  async mounted() {
    this.update();
    window.addressPopupCallback = this.addressPopupCallback;
    var checkPageShow = false;
    window.onpageshow = function (event) {
      checkPageShow = true;
      if (
        event.persisted ||
        (window.performance && window.performance.navigation.type == 2)
      ) {
        window.location.reload();
      }
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/icon.scss";

body {
  background-color: #eee !important;
}
.selectBg {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.4);
  > ul {
    width: 260px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    list-style: none;
    z-index: 9999;
    background: #fff;
    margin: 0;
    padding: 12px 16px;
    border: 1px solid #7e7e7e;
    border-radius: 6px;
    li {
      margin: 0;
      padding: 16px 0;
      border-bottom: 1px solid #fafafa;
      &:last-child {
        border-bottom: 0;
      }
    }
  }
}
.order__footer {
  display: flex;
  padding: 14px 16px;
  align-items: center;
  box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.08);
  p {
    margin-left: -8xp;
    text-align: center;
    flex: auto;
    margin: 0 0 0 -16px;
    padding: 0;
    font-size: 16px;
    font-weight: bold;
    color: #343434;
    width: 50%;
    span {
      color: #f2632a;
    }
  }
  button {
    width: 50%;
    background: #f2632a;
    line-height: 52px;
    padding: 0;
    font-size: 16px;
    font-weight: bold;
    border: none;
    border-radius: 8px;
    color: #fff;
  }
}
.order__content {
  padding: 30px 0;
  width: 100%;
  flex-grow: 1;
}
.mobile_wrap {
  max-width: 640px;
  width: 100%;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.1);
  > div {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
}
.order__receipt {
  padding: 0 16px 30px;
  p {
    font-size: 14px;
    color: #343434;
    padding: 0;
    margin: 0 0 10px;
  }
  dl {
    display: flex;
    margin: 0;
    dd {
      flex: auto;
      &:first-child {
        margin: 0 4px 0 0;
      }
      &:last-child {
        margin: 0 0 0 4px;
      }
      input {
        display: none;
      }
      input:checked + label {
        i {
          background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23FFF' d='M-56-505h360V638H-56z'/%3E%3Cg fill-rule='nonzero'%3E%3Cpath d='M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0z' fill='%23F2632A'/%3E%3Cpath d='M13.47 7.47a.75.75 0 011.133.976l-.073.084-5 5a.75.75 0 01-.976.073l-.084-.073-3-3a.75.75 0 01.976-1.133l.084.073L9 11.939l4.47-4.47z' fill='%23FFF'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        }
      }
      label {
        justify-content: center;
        align-items: center;
        width: 100%;
        border: 1px solid #dedede;
        height: 50px;
        display: flex;
        border-radius: 6px;
        i {
          margin-right: 8px;
          background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23FFF' d='M-224-505h360V638h-360z'/%3E%3Cpath d='M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zm4.53 5.97a.75.75 0 01.073.976l-.073.084-5 5a.75.75 0 01-.976.073l-.084-.073-3-3a.75.75 0 01.976-1.133l.084.073L9 11.939l4.47-4.47a.75.75 0 011.06 0z' fill='%23D8D8D8' fill-rule='nonzero'/%3E%3C/g%3E%3C/svg%3E");
          width: 20px;
          height: 20px;
          background-size: cover;
          background-position: center;
        }
        span {
          font-size: 14px;
          color: #343434;
        }
      }
    }
  }
}
.agree__list {
  list-style: none;
  padding: 20px 0 0;
  margin: 0;
  li {
    padding: 20px 16px;
    border-bottom: 1px solid #f4f4f4;
    input {
      display: none;
    }
    input:checked + label {
      i {
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Crect fill='%23F2632A' width='20' height='20' rx='4'/%3E%3Cpath stroke='%23FFF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' d='M6 9.5l2.5 3 5-5.5'/%3E%3C/g%3E%3C/svg%3E");
      }
    }
    label {
      font-size: 14px;
      color: #343434;
      display: flex;
      align-items: center;
      i {
        display: inline-block;
        margin-right: 10px;
        width: 20px;
        height: 20px;
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Crect fill='%23F4F4F4' width='20' height='20' rx='4'/%3E%3Cpath stroke='%23C3C3C3' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' d='M6 9.5l2.5 3 5-5.5'/%3E%3C/g%3E%3C/svg%3E");
      }
    }
  }
}
.payment__select {
  padding: 0 16px 0;
  p {
    font-size: 14px;
    color: #343434;
    margin: 0;
    padding: 0;
  }
  .payment_select {
    margin-top: 10px;
    border: 1px solid #d8d8d8;
    border-radius: 6px;
    padding: 12px;
    display: flex;
    align-items: center;
    i {
      width: 20px;
      height: 20px;
      margin-left: auto;
    }
  }
  .payment__money {
    padding-top: 20px;
    dl {
      display: flex;
      justify-content: flex-end;
      margin: 0;
      padding: 0;
      dd {
        p {
          text-align: right;
          margin-right: 12px;
          font-size: 14px;
          color: #343434;
          &:first-child {
            padding-bottom: 10px;
          }
        }
      }
      dt {
        p {
          text-align: right;
          font-size: 14px;
          font-weight: bold;
          color: #f2632a;
          &:first-child {
            padding-bottom: 10px;
          }
        }
      }
    }
  }
}
.delivery__info {
  padding: 0 16px 30px;
  dl {
    display: flex;
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #f4f4f4;
    &.delivery__price {
      padding-bottom: 20px;
      dd {
        &:last-child {
          font-size: 16px;
          span {
            color: #f2632a;
            font-weight: bold;
          }
        }
      }
    }
    dd {
      font-size: 14px;
      color: #343434;
      margin: 0;
      &:last-child {
        margin-left: auto;
      }
      button {
        background: #fff;
        border: 1px solid #e9e9e9;
        border-radius: 4px;
        padding: 6px 10px;
        font-size: 12px;
      }
    }
  }
  .delivery__address {
    font-size: 14px;
    color: #343434;
    background: #f4f4f4;
    border-radius: 6px;
    padding: 12px;
    word-break: keep-all;
    margin-bottom: 20px;
  }
}
.order__details {
  padding: 0 16px 30px;
  p {
    font-size: 14px;
    color: #343434;
    padding: 0;
    margin: 0 0 10px;
  }
  ul {
    padding: 0;
    margin: 0;
    background: #f4f4f4;
    border-radius: 6px;
    list-style: none;
    .product_name {
      font-size: 14px;
      font-weight: bold;
      color: #343434;
      padding: 12px;
      margin: 0;
      border-bottom: 1px solid #dedede;
    }
    li {
      margin: 0 12px;
      padding: 20px 0 0px;
      &:last-child {
        dl {
          border-bottom: 0;
        }
      }
      h3 {
        font-size: 14px;
        color: #343434;
        font-weight: bold;
        margin: 0;
      }
      dl {
        display: flex;
        padding: 0 0 10px;
        margin: 0;
        justify-content: flex-end;
        border-bottom: 1px solid #dedede;
        dd {
          font-size: 14px;
          font-weight: 400;
          color: #343434;
          margin: 0;
          margin-left: 20px;
          &:last-child {
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
